import { deepEqual } from "fast-equals";

import { clearStorage, setStorage, StorageKey } from "@/constants/storage";
import type { AppStartListening } from "@/store/listenerMiddleware";

import { selectNoneExpiredOrders } from "./selectors";
import { selectOrders } from "./slice";

export const addOrdersListeneres = (startListening: AppStartListening) => {
  startListening({
    predicate: (_action, currentState, previousState) =>
      !deepEqual(selectOrders(previousState), selectOrders(currentState)),
    effect: (_action, { getState }) => {
      const orders = selectNoneExpiredOrders(getState());

      if (orders.length > 0) {
        setStorage(StorageKey.ORDERS, orders);
      } else {
        clearStorage(StorageKey.ORDERS);
      }
    },
  });
};
